import { useState } from 'react';
import { hotRankDaily, hotRankMonthly, hotRankWeekly } from '@/mocks/hotRank';

const tabs = [
  { key: 'daily', label: '今日', data: hotRankDaily },
  { key: 'weekly', label: '本周', data: hotRankWeekly },
  { key: 'monthly', label: '本月', data: hotRankMonthly },
];

const trendMap: Record<string, { icon: string; className: string; label: string }> = {
  up: { icon: 'ri-arrow-up-line', className: 'text-primary-600', label: '上升' },
  down: { icon: 'ri-arrow-down-line', className: 'text-foreground-400', label: '回落' },
  flat: { icon: 'ri-subtract-line', className: 'text-foreground-400', label: '持平' },
};

export default function HotRank() {
  const [activeKey, setActiveKey] = useState('daily');
  const activeTab = tabs.find((tab) => tab.key === activeKey) ?? tabs[0];

  return (
    <section id="remen" className="bg-background-100 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-5">
          <div className="flex items-center gap-3">
            <span className="font-heading font-bold text-2xl md:text-3xl text-background-300 leading-none">02</span>
            <span className="w-1 h-7 rounded-full bg-primary-500"></span>
            <div>
              <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 leading-tight">封面热点榜</h2>
              <p className="mt-0.5 text-xs md:text-sm text-foreground-500">按讨论热度排序，封面直达当前最受关注的线索</p>
            </div>
          </div>
          <div className="inline-flex items-center gap-1 p-1 rounded-full border border-background-200 bg-background-50">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveKey(tab.key)}
                className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  activeKey === tab.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {activeTab.data.map((item) => {
            const trend = trendMap[item.trend] ?? trendMap.flat;
            return (
              <a
                key={`${activeKey}-${item.rank}`}
                href="#kuaixun"
                className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="relative w-full h-[170px] overflow-hidden">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} 黑料投稿${item.category}`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute top-0 left-0 w-9 h-9 rounded-br-lg bg-foreground-950/85 text-background-50 font-heading font-bold flex items-center justify-center">
                    {item.rank}
                  </span>
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-[11px] bg-background-50/90 text-foreground-800 font-label">
                    {item.category}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2">{item.title}</h3>
                  <div className="mt-3 flex items-center justify-between text-xs">
                    <span className="text-primary-600 font-label"><i className="ri-fire-line"></i> {item.heat}</span>
                    <span className={`flex items-center gap-1 ${trend.className}`}>
                      <i className={trend.icon}></i>
                      {trend.label}
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}